import React, { Fragment, useEffect } from 'react';
import { Formik } from 'formik';
import PropTypes from 'prop-types';
import { FieldLayoutSmall } from 'cstar-react-primitives';

import { useFormatMessage } from '../../../../intl/intlHooks';
import { getValidationSchema } from './samsungPayValidation';

import { AgreeToTermsField, TERMS_AGREEMENT } from '../../../forms/fields/AgreeToTermsField';
import { useUsers } from '../../../../user/UserContext';
import { SAMSUNG_PAY } from '../../paymentMethodTypes';
import { ADDRESS_EMAIL, ADDRESS_FULLNAME, ADDRESS_PHONE } from '../../../../address';
import { useSettings } from '../../../../mall_settings/SettingsProvider';
import {useOrder, statusInit} from '../../../../mapi/OrderProvider';

import { usePaymentRequest } from '../../PaymentRequestProvider';
import { formatPhoneNumberUS } from "../../../address/addressFieldFormatters";

import samsungPayImage from './images/samsung-pay-btn.inline.svg';
import {useApplyPromos} from "../../../../mapi/ApplyPromosProvider";


const SAMSUNG_MERCHANT_NAME = 'Blackhawk Network';
const ALLOWED_CARD_NETWORKS = ['mastercard', 'visa'];
const VERSION = '1';
const SUPPORTED_METHODS = 'https://spay.samsung.com';
const BILLING_ADDRESS_REQUIRED = true;
const DATA_MISSING_ERROR = 'DATA_MISSING_ERROR';


export const InnerSamsungPayForm = ({handleSubmit, setFieldValue}) => (
    <form onSubmit={handleSubmit}>
        <FieldLayoutSmall isCentered>
            <Fragment>
                <fieldset>
                    <AgreeToTermsField clickHandler={val => setFieldValue(TERMS_AGREEMENT, val)} />
                </fieldset>
                <div className="checkout-actions">
                    <button type="submit" className="btn btn--samsung-pay-button">
                        <img alt="SAMSUNG PAY" src={samsungPayImage} />
                    </button>
                </div>
            </Fragment>
        </FieldLayoutSmall>
    </form>
);

InnerSamsungPayForm.propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    setFieldValue: PropTypes.func.isRequired
};

function getWc3PaymentMethods(samsungPaySID) {
    return [
        {
            
            
            supportedMethods: SUPPORTED_METHODS,
            data: {
                version: VERSION, 
                productId: samsungPaySID, 
                allowedCardNetworks: ALLOWED_CARD_NETWORKS,
                merchantName: SAMSUNG_MERCHANT_NAME,  
                billingAddressRequired: BILLING_ADDRESS_REQUIRED
            }
        },
        
        
        
        
        
        
        
    ];
}

function getWC3PaymentDetails(value, currency) {
    return {
        
        
        
        
        
        
        
        total: {
            label: 'Total',
            amount: { currency, value }
        }
    };
}

function getW3CPaymentOptions() {
     return {
         requestPayerName: true,
         requestPayerEmail: true,
         requestPayerPhone: true
     }
}
export const SamsungPayFormik = ({ totalValue }) => {
    const { placeOrder, paymentMethodFailed, missingPaymentInfo} = useOrder();
    const { doRequest, status, setStatus, paymentData, paymentError } = usePaymentRequest();
    const { samsungPaySID } = useSettings();
    const { promoDiscounts } = useApplyPromos();
    const { totalDiscountRewardAmount = 0 } = promoDiscounts;
    const totalCostWithDiscounts = totalValue - totalDiscountRewardAmount;

    const { userData } = useUsers();
    const currencyCode = 'USD';

    const initialValues = {
        [ADDRESS_EMAIL]: userData.email || '',
        [ADDRESS_FULLNAME]: userData.firstName && userData.lastName ? `${userData.firstName} ${userData.lastName}` : '',
        [ADDRESS_PHONE]: '',
        paymentMethod: SAMSUNG_PAY,
        [TERMS_AGREEMENT]: false,
        currencyCode: 'USD',    
    };

    const serializePayment = data => {
        

        
        
        data.ccLastFour = data.paymentResponse.details.paymentInfo.card_last4digits

        
        data.email = data.paymentResponse.payerEmail

        
        data.purchaserEmail = data.paymentResponse.payerEmail

        
        data.phoneNumber = formatPhoneNumberUS(data.paymentResponse.payerPhone)
        return data;
    };

    useEffect(() => {
        if (status === 'SUCCESS') {
            serializePayment(paymentData);
            placeOrder(paymentData);
        } else if (status === 'ERROR') {
            paymentMethodFailed();
        } else if (status === DATA_MISSING_ERROR){
            missingPaymentInfo();
        }
    }, [status]);

    useEffect(() => {
        if (paymentError) {
            paymentMethodFailed();
        }
    }, [paymentError]);

    const submitHandler = (formValues) => {
        
        
        setStatus(statusInit);
        doRequest(
            formValues,
            getWc3PaymentMethods(samsungPaySID),
            getWC3PaymentDetails(totalCostWithDiscounts, currencyCode),
            getW3CPaymentOptions(),
        );
    };

    return (
        <Fragment>
            <Formik
                totalValue={totalValue}
                onSubmit={submitHandler}
                initialValues={initialValues}
                validationSchema={getValidationSchema(useFormatMessage())}
                children={formProps => <InnerSamsungPayForm {...formProps} />}
            />
        </Fragment>
    );
};

SamsungPayFormik.propTypes = {
    totalValue: PropTypes.number.isRequired
};

export default SamsungPayFormik;
